module.exports = __webpack_public_path__ + "img/parallax_clouds_desktop.b55dac06.svg";